import {useCallback, useContext, useEffect, useMemo, useState} from "react";

import {useWallet} from "use-wallet";
import {Farm} from "../contexts/Farms/types";
import {FarmModel} from "../contexts/farm_provider/stake_top_provider";
import BigNumber from "bignumber.js";
import useFarms from "./useFarms";
import {Context as FarmsContext} from "../contexts/Farms";
import quantile from '@stdlib/stats/base/dists/beta/quantile';

interface promissAllModel {
    farmModel: FarmModel,
    listCell?: Farm[]
}

export enum AllData {
    totalSupply, balanceOf, DURATION, isPause, rewardRate, reward,
}


const StakeCardHook = () => {
    const [farms] = useFarms();
    const {blockNumber} = useContext(FarmsContext);
    const {allReward} = useContext(FarmsContext);


    const [model, setModel] = useState<promissAllModel>({
        farmModel: {
            total: new BigNumber(0),
            apy: new BigNumber(0),
            averageRrturns: new BigNumber(0),
            leverage: new BigNumber(0),
            staked: new BigNumber(0),
            userAllStakeBalance: new BigNumber(0),
            getTokenAmout: new BigNumber(0),
            returns: new BigNumber(0),
        },
        listCell: []
    });

    const {account} = useWallet();


    const fetchBalance = useCallback(async () => {
        let _farmModel: promissAllModel;



        _farmModel = await _promissAll(farms, account,allReward);

        setModel({
            farmModel: _farmModel.farmModel,
            listCell: _farmModel.listCell,
        });



    }, [account, farms, model, setModel]);

    useEffect(() => {
        console.log(123123);
        if (account && farms.length != 0) {
            fetchBalance()
        }
    }, [account,blockNumber]);

    return model;
};

export default StakeCardHook;


async function _promissAll(farms: Farm[], account: String, allReward:number): Promise<promissAllModel> {
    let staked = new BigNumber('0');
    let total = new BigNumber('0');
    let averageRrturns = new BigNumber('0');
    let returns = new BigNumber('0');
    let userAllStakeBalance = new BigNumber('0');
    let getTokenAmout: BigNumber= new BigNumber(0), leverage: BigNumber = new BigNumber(0);
    getTokenAmout =new BigNumber(await farms[0].lpContract.methods.balanceOf(account).call());
    const _list = await Promise.all(
        farms.map(
            async (item: Farm, i) => {
                if (!item.sC.options.address) return;
                const allData = await item.sC.methods.allValues(account).call();
                const balance = allData[AllData.balanceOf];
                const totalSupply = allData[AllData.totalSupply]; // 全部stake
                    let earned = allData[AllData.reward]; // 奖励
                    let rewardRate = allData[AllData.rewardRate]; // 奖励
                    const isPause: boolean = allData[AllData.isPause];
                    total = total.plus(new BigNumber(earned));
                    userAllStakeBalance = userAllStakeBalance.plus(new BigNumber(balance));
                    farms[i].tokenBalance = new BigNumber(balance);
                    farms[i].earning = new BigNumber(earned);
                    farms[i].isPause = isPause;

                    farms[i].premium = farms[i].tsl * quantile(.95,farms[i].tsl * 0.0001 *farms[i].raf, totalSupply*4 /1e18 * 0.0003);
                if(!farms[i].premium) farms[i].premium = 0;
                    // farms[i].apy = new BigNumber(totalSupply > 0 ? rewardRate * 365 * 24 * 60 * 60 / totalSupply * 100 : 0);
                    if (totalSupply != 0) {
                        // farms[i].apy = (new BigNumber(allReward).times(item.tsl).div(allTsl).div(totalSupply).toNumber() * 100 / 14 * 365).toFixed(2);
                        // farms[i].averageRrturns = new BigNumber(rewardRate * allData[AllData.DURATION] * balance / totalSupply);
                        farms[i].averageRrturns = new BigNumber(rewardRate * 14 * 24 * 3600 * balance / totalSupply);
                        farms[i].totalSupply = new BigNumber(totalSupply);
                        averageRrturns = averageRrturns.plus( farms[i].averageRrturns);
                    }

                staked = staked.plus(new BigNumber(totalSupply),);
                return farms[i];

            },
        ),
    );
    const listFarm: Farm[] = [];
    let _allPremium = 0;
    _list.map(({premium})=>{
        _allPremium += premium;
    });

    _list.map((item:Farm,)=>{
        if(item.tokenBalance.toNumber() > 0 || item.earning.toNumber() > 0){
            item.apy = (new BigNumber(allReward).times(item.premium).div(_allPremium).div(item.totalSupply).toNumber() * 100 / 14 * 365).toFixed(2)
            listFarm.push(item);
        }
    });


    if(!userAllStakeBalance.isEqualTo(0) ) {
        if( !getTokenAmout.isEqualTo(0)){
            leverage = userAllStakeBalance.times(4).div(userAllStakeBalance.plus(getTokenAmout),);
        }


        if(!averageRrturns.isEqualTo(0)){
            returns = averageRrturns.times(2600).div(userAllStakeBalance);
        }
    }

    return {
        farmModel: {
            total: total,
            staked: staked,
            averageRrturns: averageRrturns,
            userAllStakeBalance: userAllStakeBalance,
            getTokenAmout: getTokenAmout,
            returns:returns,
            leverage: leverage
        }, listCell: listFarm
    };
}
